import { useMemo } from 'react'
import { useAuthProvider } from '@maui-mf/common-react'
import { userAccessToResource, genHasEntitlements } from './auth/entitlements'

export const useHasAccessToObject = () => {
  const { claims } = useAuthProvider()

  return useMemo(() => {
    const hasEntitlements = genHasEntitlements(claims)
    return object => userAccessToResource(object, hasEntitlements)
  }, [claims])
}
